<template>
<div>
	<div class="dynamicLabel" @click="handleTextClick" :style="style" :class="{editable: settings.editable && mode === 'view'}"
	v-if="realtimeData.state === true && mode === 'view'">
		<div v-if="!editing" class="text">
			{{this.realtimeData.text}}
		</div>
		<template v-else>
			<el-input class="editTextInput" type="textarea" v-model="tmpText"></el-input>
		</template>
	</div>
	<div class="dynamicLabel" @click="handleTextClick" :style="style" :class="{editable: settings.editable && mode === 'view'}"
	v-if="mode === 'edit'">
		<div v-if="!editing" class="text">
			{{this.realtimeData.text}}
		</div>
		<template v-else>
			<el-input class="editTextInput" type="textarea" v-model="tmpText"></el-input>
		</template>
	</div>
  <el-dialog :style="dialogStyle"
      title="子窗口页面"
      :visible.sync="modalShow"
      :width="realtimeData.modalValue+'px'"
      @close="modalShow=false"
      append-to-body>
    <div :style="modelStyle">
      <div style="width: 100%; ">
        <the-create style="width: 100%;" :companyId="companyId" :productId="realtimeData.pageId" :projectId="productSaveForm.projectId" :editType="3" :dialogCount="dialogCount+1" :readPublished="true"></the-create>
      </div>
    </div>
  </el-dialog>
</div>
</template>
		
<script>
	import componentsMixin from "../componentsMixin";

	export default {
		name: 'dynamicLabel',
		mixins: [componentsMixin],
		data() {
			return {
				editing: false,
				tmpText: '',
        timeOutId:'',
			}
		},
    mounted(){
        this.timeOutId = setInterval(this.getSystemTimeAndThrow,1000)
    },
    beforeDestroy() {
      clearInterval(this.timeOutId)
    },
    methods: {
      //一秒钟时间标签改变一次
      getSystemTimeAndThrow(){
        if(this.realtimeData.time){
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const hours = String(currentDate.getHours()).padStart(2, '0');
          const minutes = String(currentDate.getMinutes()).padStart(2, '0');
          const seconds = String(currentDate.getSeconds()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          this.realtimeData.text = formattedDate;
        }
      },
			appearDynamicabel(){
				this.settings.state = true
			},
			disappearDynamicLabel(){
				this.settings.state = false
			},
			handleTextClick() {
				if(this.mode === 'edit' || !this.settings.editable || this.editing){
          this.handleClick()
          return
        }
				this.editing = true
				this.tmpText = this.text
				document.onclick = (e) => {
					if(e.path.indexOf(this.$el) === -1) {
						this.modifyVar()
						this.editing = false
						document.onclick = null
					}
				}
				this.handleClick()
			},
			modifyVar() {
				console.log('1111this.settings.text=',this.settings.text)
				console.log('1111this.settings.text.varName=',this.settings.text.varName)  
				if(this.settings.text.varName === undefined){ //未绑定变量
					this.$set(this.realtimeData,'text',this.tmpText)
					this.$set(this.settings,'text',this.tmpText)
				}
				else{ //绑定变量
					console.log('this.tmpText的值',this.tmpText)
					this.$set(this.realtimeData,'text',this.tmpText)   
					this.$bus.$emit('var-change', this.settings.text.varName, this.tmpText)  //参数是变量名和实时标签显示的文本
				}
				// console.log('this.tmpText的值',this.tmpText)
				// this.$set(this.realtimeData,'text',this.tmpText)
				// this.$set(this.settings,'text',this.tmpText)
				// console.log('this.tmpText的值覆盖',this.realtimeData.text)
				// this.$bus.$emit('var-change', this.realtimeData.text, this.tmpText)
			}
		},
		computed: {
      dialogStyle(){
        if(this.realtimeData.modalX === undefined && this.realtimeData.modalY === undefined ){
          var applyLeft = '0'
          var applyTop = '0'
        }else if(this.realtimeData.modalX.length == 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = '0'
          var applyTop = '0'
        }else if(this.realtimeData.modalX.length !== 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = this.realtimeData.modalX
          var applyTop = '0'
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length == 0) {
          var applyLeft = '0'
          var applyTop = this.realtimeData.modalY
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length !== 0) {
          var applyLeft = this.realtimeData.modalX
          var applyTop = this.realtimeData.modalY
        }
        return {
          top:`calc(${applyTop}px + 10vh)`,
          left: applyLeft + 'px',
        }
      },
			text() {
				return this.realtimeData.text
			}
		},
		watch: {
			"realtimeData.textColor": {
				handler() {
					this._style["color"] = this.realtimeData.textColor
				}
			},
			"realtimeData.labelColor": { //标签颜色
				handler() {
					this._style["background-color"] = this.realtimeData.labelColor
				}
			},
			"realtimeData.borderColor": { //标签边框颜色
				handler() {
					this._style["border-color"] = this.realtimeData.borderColor
				}
			},
			'realtimeData.textSize':{ //文本字体大小
				handler(){
					this._style["font-size"] = this.realtimeData.textSize + 'px'
				}
			},
			'realtimeData.textStyle':{ //文本字体样式
				handler(){
					this._style["font-family"] = this.realtimeData.textStyle
				}
			},
			'realtimeData.borderWidth':{ //标签边框粗细
				handler(){
					this._style["border-width"] = this.realtimeData.borderWidth + 'px'
				}
			},
      'realtimeData.top': {  // x绑定
        handler() {
          this.wrapperStyle.top = this.realtimeData.top +'px'
        }
      },
      'realtimeData.left': {  // y绑定
        handler() {
          this.wrapperStyle.left = this.realtimeData.left +'px'
        }
      },
      'realtimeData.height': {  // 高度绑定
        handler() {
          this._style.height = this.realtimeData.height + 'px'  // componentsMixin 中对 _style 进行了检查更新style 绑定至矩形框
          this.wrapperStyle.height = this.realtimeData.height +'px'
        }
      },
      'realtimeData.width': {  // 宽度绑定
        handler() {
          console.log("宽度发生改变",this.realtimeData.width,this.style)
          this._style.width = this.realtimeData.width + 'px'
          this.wrapperStyle.width = this.realtimeData.width +'px'  // 编辑框
        }
      },
		}
	}
</script>

<style lang="less" scoped>
	.dynamicLabel {
		&.editable {
			cursor: text;
		}
		border: 1px solid black;
		display: flex;
		align-items: center;
		justify-content: center;
		.editTextInput {
			width: 100%;
			height: 100%;
		}
	}
  ::v-deep .el-dialog{
    margin:0 !important;
    position:absolute;
  }
</style>
